import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { httpOptions, api, serviceConstants, formOptions, imageOptions } from '../constants/service.constants';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { LogOutModel } from '../models/common';
import { AesEncriptionDecriptionService } from './common/aes-encription-decription.service';


@Injectable({
  providedIn: 'root'
})
export class UserService {

  userData: Observable<any>;
  userDetails;
  istcurrencyid: string;
  eapcurrencyid: string;
  // grants1currencyid: string; ////CME
  // grants2currencyid: string; ////sponsorship
  // grants3currencyid: string; ////charitable

  grantsCMEcurrencyid: string; ////CME
  grantssponsorshipcurrencyid: string; ////sponsorship
  grantscharitablecurrencyid: string; ////charitable

  token: string;

  loggedInStatus = JSON.parse(localStorage.getItem('loggedIn') || 'false');

  constructor(private http: HttpClient, public router: Router, private securityService:AesEncriptionDecriptionService) {

  }

  clearUserData() {
    this.userDetails = null;;
    this.istcurrencyid = undefined;
    this.eapcurrencyid = undefined;
    this.grantsCMEcurrencyid = undefined;
    this.grantssponsorshipcurrencyid = undefined;
    this.grantscharitablecurrencyid = undefined;
    this.token = undefined;
  }

  getUserData(_id): Observable<any> {
    //if (this.userDetails)
    return this.userDetails;
    //this.userData = this.http.get(api +'/users/'+_id, httpOptions).map(res=> res).shareReplay();
    //return this.userData;
  }

  fetchTimeZones():Observable<any> 
  {
    return this.http.get(serviceConstants.apiURL + 'api/appuser/fetchtimezones', httpOptions);
  }
  timeZoneAutoSave(TimeZone:any):Observable<any>{
   // let requesturl = encodeURIComponent(serviceConstants.apiURL + 'api/appuser/timezoneautosave/?TimeZone=' + TimeZone);
      return this.http.post(serviceConstants.apiURL + 'api/appuser/timezoneautosave/' + TimeZone,  TimeZone , httpOptions);
  }

  GetWindowsTimeZoneFromIANA(TimeZone:any):Observable<any>{
    return this.http.post(serviceConstants.apiURL + 'api/appuser/GetWindowsTimeZoneFromIANA/' + TimeZone , TimeZone, httpOptions);
  }

  userLogin(request): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/appuser/login', request, httpOptions);
    //return this.http.post(api + '/login', request, httpOptions);
  }
  MultiBrowserVerification(request): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/appuser/MultiBrowserVerification', request, httpOptions);
    //return this.http.post(api + '/login', request, httpOptions);
  }
  checkUserType(email): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/appuser/checkusertype', email, httpOptions);
    //return this.http.post(api + '/login', request, httpOptions);
  }

  getSSOConfig(orgid: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/appuser/getssoconfig/' + orgid, imageOptions);
  }

  checkSession(): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/appuser/checksession', imageOptions);
  }

  getLogo(code: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/appuser/downloadifle/' + code, imageOptions);
  }

  getInstruction(): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/common/getinstruction', httpOptions);
  }

  GetUsersRoles(id): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/appuser/getur/' + id, httpOptions);
  }

  setLogoImage(image) {
    localStorage.setItem("_lo_img_", image);
  }

  getLogoImage() {
    return localStorage.getItem("_lo_img_");
  }

  userLogout(model: LogOutModel): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/appuser/logout/', model, httpOptions);
  }

  setLoggedIn(value: boolean) {
    this.loggedInStatus = value;
    localStorage.setItem('_U_log', 'true');
  }

  get isLoggedIn() {
    return JSON.parse(localStorage.getItem('_U_log') || this.loggedInStatus.toString())
  }

  



  //IST--SET,GET-ID,SYMBOL,CODE

  setISTCurrency(currencyid) {
    this.istcurrencyid = currencyid;
    let encriptedStr=this.securityService.encryptionAES(currencyid)
    localStorage.setItem('_I_CUR_ID_', encriptedStr);
  }

  getISTCurrencyID() {
    if (this.istcurrencyid === null || this.istcurrencyid === undefined) {
      let decriptedStr=this.securityService.decryptionAES(localStorage.getItem("_I_CUR_ID_"))
      return decriptedStr;
    }
    return this.istcurrencyid;
  }
  setISTCurrencysymbol(currencysumbol) {

    localStorage.setItem('IST_CURRENCY_SYMBOL', currencysumbol);
  }

  getISTCurrencySymbol() {
    return this.userDetails.IST_CURRENCY_SYMBOL;
  }

  setISTCurrencycode(currencycode) {
    localStorage.setItem('IST_CURRENCY_CODE', currencycode);
  }

  getISTCurrencyCode() {
    return this.userDetails.IST_CURRENCY_CODE;
  }

  
  
  //EAP--SET,GET-ID,SYMBOL,CODE

  setEAPCurrency(currencyid) {
    this.eapcurrencyid = currencyid;
    localStorage.setItem('_E_CUR_ID_', currencyid);
  }

  getEAPCurrencyID() {
    if (this.eapcurrencyid === null || this.eapcurrencyid === undefined) {
      this.eapcurrencyid = localStorage.getItem("_E_CUR_ID_");
    }
    return this.eapcurrencyid;
  }

  setEAPCurrencysymbol(currencysymbol) {
    localStorage.setItem('EAP_CURRENCY_SYMBOL', currencysymbol);
  }

  getEAPCurrencySymbol() {
    return this.userDetails.EAP_CURRENCY_SYMBOL;
  }
  
  setEAPCurrencycode(currencycode) {
    localStorage.setItem('EAP_CURRENCY_CODE', currencycode);
  }

  getEAPCurrencyCode() {
    return this.userDetails.EAP_CURRENCY_CODE;
  }

  // getEAPCurrency() {
  //   if (this.eapcurrencyid === null || this.eapcurrencyid === undefined) {
  //     this.eapcurrencyid = localStorage.getItem("EAPCURRENCYID");
  //   }
  //   return this.eapcurrencyid;
  // }


  //CME--1--SET,GET-ID,SYMBOL,CODE
  
  setGrantsCMECurrency(currencyid) {
    this.grantsCMEcurrencyid = currencyid;
    localStorage.setItem('_G_CM_CUR_ID', currencyid);
  }

  getCMECurrencyID() {
    if (this.grantsCMEcurrencyid === null || this.grantsCMEcurrencyid === undefined) {
      this.grantsCMEcurrencyid = localStorage.getItem("_G_CM_CUR_ID");
    }
    return this.grantsCMEcurrencyid;
  }

  setGrantsCMECurrencysymbol(currencysymbol) {
    localStorage.setItem('GRANTS_CME_CURRENCY_SYMBOL', currencysymbol);
  }
 
  setGrantsCMECurrencycode(currencycode) {
    localStorage.setItem('GRANTS_CME_CURRENCY_CODE', currencycode);
  }

  getGrantCMECurrencyCode() {
    return this.userDetails.GRANTS_CME_CURRENCY_CODE;
  }

 



 //sponsorship--2--SET,GET-ID,SYMBOL,CODE
 
  setGrantssponsorshipCurrency(currencyid) {
    this.grantssponsorshipcurrencyid = currencyid;
    localStorage.setItem('_G_SPON_CUR_ID_', currencyid);
  }

  getSponsorCurrencyId() {
    if (this.grantssponsorshipcurrencyid === null || this.grantssponsorshipcurrencyid === undefined) {
      this.grantssponsorshipcurrencyid = localStorage.getItem("_G_SPON_CUR_ID_");
    }
    return this.grantssponsorshipcurrencyid;
  }

  setGrantssponsorshipCurrencysymbol(currencysymbol) {
    localStorage.setItem('GRANTS_SPONSOR_CURRENCY_SYMBOL', currencysymbol);
  }

  

  setGrantssponsorshipCurrencycode(currencycode) {
    localStorage.setItem('GRANTS_SPONSOR_CURRENCY_CODE', currencycode);
  }

  getGrantSponsorCurrencyCode() {
    return this.userDetails.GRANTS_SPONSOR_CURRENCY_CODE;
  }

  getGrantSponsorCurrencySymbol(appID:any="0"):any {
    return  this.http.get(serviceConstants.apiURL + 'api/common/getCurrencySymbol/sponsor/'+appID, httpOptions)
  }

  getGrantCharitableCurrencySymbol(appID:any="0"):any {
    return  this.http.get(serviceConstants.apiURL + 'api/common/getCurrencySymbol/charity/'+appID, httpOptions)
  }
 getGrantCMECurrencySymbol(appID:any="0"){
    return  this.http.get(serviceConstants.apiURL + 'api/common/getCurrencySymbol/cme/'+appID, httpOptions)
  }


 

  setGrantscharitableCurrency(currencyid) {
     this.grantssponsorshipcurrencyid = currencyid;
     localStorage.setItem('_G_CHA_CUR_ID_', currencyid);
   }
 
  getCharitableCurrencyID() {
    if (this.grantssponsorshipcurrencyid === null || this.grantssponsorshipcurrencyid === undefined) {
      this.grantssponsorshipcurrencyid = localStorage.getItem("_G_CHA_CUR_ID_");
    }
    return this.grantssponsorshipcurrencyid;
  }

  setGrantscharitableCurrencysymbol(currencysymbol) {
    localStorage.setItem('GRANTS_CHARITABLE_CURRENCY_SYMBOL', currencysymbol);
  }

  

  setGrantscharitableCurrencycode(currencycode) {
    localStorage.setItem('GRANTS_CHARITABLE_CURRENCY_CODE', currencycode);
  }
  
  getGrantCharitableCurrencyCode() {
    return this.userDetails.GRANTS_CHARITABLE_CURRENCY_CODE;
  }

  setLoggedUserTimeFormat(LoggedUserTimeFormat) {
    let encriptedStr=this.securityService.encryptionAES(LoggedUserTimeFormat)
    localStorage.setItem('_UTF_', encriptedStr);
  }
  getLoggedUserTimeFormat() {
    let decriptedStr=this.securityService.decryptionAES(localStorage.getItem("_UTF_"))
    return decriptedStr;
  }

  setLoggedUserDateFormat(LoggedUserDateFormat) {
    let encriptedStr=this.securityService.encryptionAES(LoggedUserDateFormat)
    localStorage.setItem('_UDF_', encriptedStr);
  }

  getLoggedUserDateFormat() {
    let decriptedStr=this.securityService.decryptionAES(localStorage.getItem("_UDF_"))
    return decriptedStr;
   }

  setLoggedUserOrgTimeZone(LoggedUserOrgTimeZone) {
    let encriptedStr=this.securityService.encryptionAES(LoggedUserOrgTimeZone)
    localStorage.setItem('_UOTZ_', encriptedStr);
  }
  getLoggedUserOrgTimeZone():any {
    let decriptedStr=this.securityService.decryptionAES(localStorage.getItem("_UOTZ_"))
    return decriptedStr;
   }
 setLoggedUserID(_id)
 {
  let encriptedStr=this.securityService.encryptionAES(_id)
  localStorage.setItem("u_i_d", encriptedStr);
 }
 getLoggedUserID()
 {
  let decriptedStr=this.securityService.decryptionAES(localStorage.getItem("u_i_d"))
  return decriptedStr;
 }
 
  getLoggedUserTimeZone() {
    let decriptedStr=this.securityService.decryptionAES(localStorage.getItem("U_trhe_T_sdji_Z"))
    return decriptedStr;
  }
  setLoggedUserTimeZone(LoggedUserTimeZone) {
    let encriptedStr=this.securityService.encryptionAES(LoggedUserTimeZone)
    localStorage.setItem("U_trhe_T_sdji_Z", encriptedStr);
  }
 
  setToken(token: string) {
    this.token = token;
    localStorage.setItem('_auth_', token);
  }

  getToken() {
    if (this.token === null || this.token === undefined) {
      this.token = localStorage.getItem("_auth_");
    }
    return this.token;
  }

  getOrgCode(): string {
    let decriptedStr=this.securityService.decryptionAES(localStorage.getItem("org_grhtw56fgh_C"))
    return decriptedStr;
  }

  setOrgCode(code: string) {
    let encriptedStr=this.securityService.encryptionAES(code)
    localStorage.setItem("org_grhtw56fgh_C", encriptedStr);
  }
  setUserDetails(_userDetails) {
    this.userDetails = _userDetails;
    let encriptedStr=this.securityService.encryptionAES(JSON.stringify(this.userDetails))
    localStorage.setItem("u_rT2WeX2jiY_Dtl", encriptedStr);
  }

  getUserDetais() {
    if (this.userDetails === null || this.userDetails === undefined) {
      let decriptedStr=this.securityService.decryptionAES(localStorage.getItem("u_rT2WeX2jiY_Dtl"))
      this.userDetails = JSON.parse(decriptedStr);
    }

    return this.userDetails;
  }
  removeUserDetails() {
    localStorage.removeItem("u_rT2WeX2jiY_Dtl");
  }
  getUserID() {
    if (this.userDetails === null || this.userDetails === undefined) {
      this.userDetails = this.getUserDetais();
    }
    return this.userDetails.ID;
  }
  getUserType(): string {
    if (this.userDetails === null || this.userDetails === undefined) {
      this.userDetails =  this.getUserDetais();
    }

    return this.userDetails.USER_TYPE;
  }

  getUserName(): string {
    if (this.userDetails === null || this.userDetails === undefined) {
      this.userDetails =  this.getUserDetais();
    }
    let username = "";
    if (this.userDetails.FIRST_NAME !== null)
      username = this.userDetails.FIRST_NAME;
    if (this.userDetails.MIDDLE_NAME !== null)
      username = username + this.userDetails.MIDDLE_NAME;
    if (this.userDetails.LAST_NAME !== null)
      username = username + this.userDetails.LAST_NAME;
    return username;
  }

  getOrganizationId(): string {
    if (this.userDetails === null || this.userDetails === undefined) {
      this.userDetails =  this.getUserDetais();
    }

    return this.userDetails.ORGANIZATION_ID;
  }

  logout(LogOutReason: string, Browser: string, Version: string) {
    let orgCode = this.getOrgCode();
    let user = this.getUserDetais();
    //localStorage.clear();
    let model = new LogOutModel();
    model.Reason = LogOutReason;
    model.Browser = Browser;
    model.Version = Version;
    model.UserId =  user.ID;

    this.userLogout(model).subscribe(result => {
      if (result.Status == 0) {
        localStorage.clear();
        if (orgCode !== null && orgCode !== "undefined" && orgCode !== '')
        {
          //this.router.navigateByUrl(orgCode + '/login');
          window.location.replace(orgCode + '/login');
        }
        else{
          //this.router.navigateByUrl('/login');
          window.location.replace('/login');
        }
      }
    })
  }

  logoutUserInOtherBrowser = (Id: string, browser: string) => {
    return this.http.get(serviceConstants.apiURL + "api/appuser/LogoutUserInOtherBrowser/" + Id + '/' + browser);
  }

  detectBrowserName() {
    var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return { name: 'IE', version: (tem[1] || '') };
    }
    if (M[1] === 'Chrome') {
      tem = ua.match(/\bEdg\/(\d+)/)
      if (tem != null) { return { name: 'Edge(Chromium)', version: tem[1] }; }
      tem = ua.match(/\bOPR\/(\d+)/)
      if (tem != null) { return { name: 'Opera', version: tem[1] }; }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) { M.splice(1, 1, tem[1]); }
    return {
      name: M[0],
      version: M[1]
    };
  }



}

